import React, { useEffect, useState } from 'react';
import NavBar from '../components/Navbar/NavBar';
import Footer from '../components/Footer';
import {useDocTitle} from '../components/CustomHook';
import axios from 'axios';
// import emailjs from 'emailjs-com';
import Notiflix from 'notiflix';

import ActiveCallDetail from "../components/Vapi/ActiveCallDetail";
import Button from "../components/Vapi/base/Button";
import Vapi from "@vapi-ai/web";
import { isPublicKeyMissingError } from "../utils";
import { PIZZERIA_EN_MESSAGES } from "../utils/constants";


const VoiceAgent = (props) => {

    useDocTitle('Voice agents - Demo our products')
//public api key = 309bcace-9bf1-4c03-a948-acf18a1a72a6

    //vapi settings
    const vapi = new Vapi("309bcace-9bf1-4c03-a948-acf18a1a72a6");//public key
    //309bcace-9bf1-4c03-a948-acf18a1a72a6
    const [connecting, setConnecting] = useState(false);
    const [connected, setConnected] = useState(false);
    const [assistantIsSpeaking, setAssistantIsSpeaking] = useState(false);
    const [volumeLevel, setVolumeLevel] = useState(0);
    
// hook into Vapi events
useEffect(() => {
    vapi.on("call-start", () => {
      setConnecting(false);
      setConnected(true);

      setShowPublicKeyInvalidMessage(false);
    });

    vapi.on("call-end", () => {
      setConnecting(false);
      setConnected(false);

      setShowPublicKeyInvalidMessage(false);
    });

    vapi.on("speech-start", () => {
      setAssistantIsSpeaking(true);
    });

    vapi.on("speech-end", () => {
      setAssistantIsSpeaking(false);
    });

    vapi.on("volume-level", (level) => {
      setVolumeLevel(level);
    });

    vapi.on("error", (error) => {
      console.error(error);

      setConnecting(false);
      if (isPublicKeyMissingError({ vapiError: error })) {
        setShowPublicKeyInvalidMessage(true);
      }
    });

    // we only want this to fire on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const usePublicKeyInvalid = () => {
    const [showPublicKeyInvalidMessage, setShowPublicKeyInvalidMessage] = useState(false);
  
    // close public key invalid message after delay
    useEffect(() => {
      if (showPublicKeyInvalidMessage) {
        setTimeout(() => {
          setShowPublicKeyInvalidMessage(false);
        }, 3000);
      }
    }, [showPublicKeyInvalidMessage]);
  
    return {
      showPublicKeyInvalidMessage,
      setShowPublicKeyInvalidMessage,
    };
  };
  const { showPublicKeyInvalidMessage, setShowPublicKeyInvalidMessage } = usePublicKeyInvalid();

  // call start handler
  const startCallInlineForPizza = () => {
    setConnecting(true);
    //vapi.start(assistantOptions);
    vapi.start("88af7788-f598-4efc-a5e2-e8f29fe7bdb2"); // for trax.
  };
  const startCallOutboundForCreditCard = () => {
   // setConnecting(true);
    //vapi.start(assistantOptions);
    alert("This is being implemented..")
   // vapi.start("88af7788-f598-4efc-a5e2-e8f29fe7bdb2"); // for trax.
  };
  const endCall = () => {
console.log("end call clicked");
setConnecting(true);
try {
  setConnected(false);
  vapi.stop();
}
catch(err) {
  console.error('Error while stopping the meeting:', err);
}
    
  };
  const assistantOptions = {
    name: "Vapi’s Pizza Front Desk",
    firstMessage: "Vappy’s Pizzeria speaking, how can I help you?",
    transcriber: {
      provider: "deepgram",
      model: "nova-2",
      language: "en-US",
    },
    voice: {
      provider: "playht",
      voiceId: "jennifer",
    },
    model: {
      provider: "openai",
      model: "gpt-4",
      messages: [
        {
          role: "system",
          content: PIZZERIA_EN_MESSAGES,
        },
      ],
    },
  };
  const PleaseSetYourPublicKeyMessage = () => {
    return (
      <div
        style={{
          position: "fixed",
          bottom: "25px",
          left: "25px",
          padding: "10px",
          color: "#fff",
          backgroundColor: "#f03e3e",
          borderRadius: "5px",
          boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
        }}
      >
        Is your Vapi Public Key missing? (recheck your code)
      </div>
    );
  };

  //vapi ends here

    return (
        <>
            <div>
                <NavBar />
            </div>
            <div className="vapi-container container w-full">
            
            </div>
            <div id='voiceAgent' className="flex justify-center items-center mt-8 w-full bg-white py-12 lg:py-24">
                <div className="container mx-auto my-8 px-4 lg:px-20" data-aos="zoom-in">
                        <div className="w-full bg-white p-8 my-4 md:px-12 lg:w-9/12 lg:pl-20 lg:pr-40 mr-auto rounded-2xl shadow-2xl">
                            <div className="flex">
                                <h1 className="font-bold text-center lg:text-left text-blue-900 uppercase text-4xl">Demo our products</h1>
                            </div>
                            <div className="flex items-center my-4">
                            {!connected ? (
        <Button
          label="Call Pizza Front Desk"
          onClick={startCallInlineForPizza}
          isLoading={connecting}
        />
      ) : (
        <ActiveCallDetail
          assistantIsSpeaking={assistantIsSpeaking}
          volumeLevel={volumeLevel}
          onEndCallClick={endCall}
        />
      )}
       
      {showPublicKeyInvalidMessage ? <PleaseSetYourPublicKeyMessage /> : null} 
      </div>
                    </div>
                   
                </div>
            </div>
            <Footer />
        </>


    )
}

export default VoiceAgent;